/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import * as React from 'react';
import * as PropTypes from 'prop-types';
var isFocusable = function (element) {
    if (element.tabIndex > 0 ||
        (element.tabIndex === 0 && element.getAttribute('tabIndex') !== null)) {
        return true;
    }
    if (element.disabled) {
        return false;
    }
    switch (element.nodeName) {
        case 'A':
            return (!!element.href &&
                element.rel !== 'ignore');
        case 'INPUT':
            return (element.type !== 'hidden' &&
                element.type !== 'file');
        case 'BUTTON':
        case 'SELECT':
        case 'TEXTAREA':
            return true;
        default:
            return false;
    }
};
var attemptFocus = function (element) {
    if (!isFocusable(element)) {
        return false;
    }
    try {
        element.focus();
    }
    catch (e) {
        /* skip */
    }
    return document.activeElement === element;
};
var focusFirstDescendant = function (element) {
    var childNodes = Array.from(element.childNodes);
    var focused = childNodes.find(function (child) {
        return attemptFocus(child) ||
            focusFirstDescendant(child);
    });
    return !!focused;
};
var focusLastDescendant = function (element) {
    var childNodes = Array.from(element.childNodes).reverse();
    var focused = childNodes.find(function (child) {
        return attemptFocus(child) ||
            focusLastDescendant(child);
    });
    return !!focused;
};
var onFocus = function (target, f) { return function () {
    if (target && target.current)
        f(target.current);
}; };
/**
 * Prevents users from focusing elements outside the current
 * Modal. Only elements inside the TabTrap can be focused.
 */
export var TabTrap = function (_a) {
    var innerTrapRef = _a.innerTrapRef, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { tabIndex: 0, onFocus: onFocus(innerTrapRef, focusLastDescendant) }),
        children,
        React.createElement("div", { tabIndex: 0, onFocus: onFocus(innerTrapRef, focusFirstDescendant) })));
};
TabTrap.propTypes = {
    innerTrapRef: PropTypes.shape({
        // eslint-disable-next-line react/forbid-prop-types
        current: PropTypes.any,
    }),
    children: PropTypes.node,
};
//# sourceMappingURL=TabTrap.js.map